export default "__VITE_ASSET__eb9d38fc__"